async function hashValue(value: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(value.toLowerCase().trim());
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}

export async function trackCreateAccount(email: string) {
  const userIDHashed = await hashValue(email);
  dataLayer.push({
    event: 'carrierSignupForm',
    signupStep: 'Step 1',
    signupStepName: 'Create Account',
    email: email,
    userID: userIDHashed,
  });
}

export function trackContactInfo(values: Record<string, any>) {
  dataLayer.push({
    event: 'carrierSignupForm',
    signupStep: 'Step 3',
    signupStepName: 'Contact Info',
    optIn: values.subscriptions ? 'Yes' : 'No',
    companyName: values.company_name,
    firstName: values.first_name,
    lastName: values.last_name,
    phoneNumber: values.phoneNumber,
  });
}

export function trackAdditionalInfo(values: Record<string, any>) {
  dataLayer.push({
    event: 'carrierSignupForm',
    signupStep: 'Step 4',
    signupStepName: 'Additional Info',
    role: values.role === 'Other' ? values.role_other : values.role,
    drivers: values.number_of_trucks,
    howdYouHearAboutUs:
      values.comment === 'Other' ? values.referralSource : values.comment,
  });
}

export function trackVerifyEmailSuccess() {
  dataLayer.push({
    event: 'carrierSignupForm',
    signupStep: 'Step 2',
    signupStepName: 'Email Verification',
  });
}

export function trackVerifyEmailFailed() {
  dataLayer.push({
    event: 'carrierSignupForm',
    signupStep: 'Step 2a',
    signupStepName: 'Email Verification Failed',
  });
}

export function trackVerifyUSDOTSuccess() {
  dataLayer.push({
    event: 'carrierSignupForm',
    signupStep: 'Step 5',
    signupStepName: 'US Dot Verification',
  });
}

export function trackVerifyUSDOTFailed() {
  dataLayer.push({
    event: 'carrierSignupForm',
    signupStep: 'Step 4a',
    signupStepName: 'US Dot Verification Fail',
  });
}
